var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"constructionRequirements__icons"},_vm._l((_vm.features),function(feature){return _c('img',{attrs:{"src":'/wp-content/themes/rigips/images/icon/' + feature.icon,"alt":feature.name}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4efb8ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calculation/calculator/construction/feature/ConstructionFeatureList.vue
// module id = null
// module chunks = 